import formatRoomsRequest from './formatRoomsRequest';

const formatHotelDetailRequest = (itinerary, staterooms, searchObj, isDedicatedHotelPage) => ({
  hotelProvider: itinerary.hotel.priceProvider ?? undefined,
  ...itinerary.hotel.ids,
  checkInDate: itinerary.hotel.checkInStartTime,
  checkOutDate: itinerary.hotel.checkOutEndTime,
  rateCodes: isDedicatedHotelPage ? itinerary.hotel.rateCodes : searchObj && searchObj.rateCodes,
  exactMatchRateCodesOnly: isDedicatedHotelPage
    ? itinerary.hotel.exactMatchRateCodesOnly : searchObj && searchObj.exactMatchRateCodesOnly,
  doGetCommissionableRatesOnly: isDedicatedHotelPage
    ? itinerary.hotel.doGetCommissionableRatesOnly
    : searchObj && searchObj.doShowCommissionableRatesOnly,
  showRefundableHotelRatesOnly: isDedicatedHotelPage
    ? itinerary.hotel.showRefundableHotelRatesOnly
    : searchObj && searchObj.showRefundableHotelRatesOnly,
  ...formatRoomsRequest(staterooms),
});

export default formatHotelDetailRequest;
